import { GET_BILLING_CONTACT_DETAILS_DONE } from '../actions';
const initState = {
    billingContacts: {}
}
const billingContacts = (state = initState, action) => {    //NOSONAR
    if(action.type == GET_BILLING_CONTACT_DETAILS_DONE) {
        return action.payload;
    }
    return state;
}
export default billingContacts;